import { Dropdown } from "antd"
import PropTypes from "prop-types"
import MoreActionEllipsis from "ui/MoreActionEllipsis"
import { Text } from "ui/Typography"
import TimeOffNotFound from "../TimeOffNotFound"
import { getTimeOffColumns, TIME_OFF_BE_KEYS } from "pagesV2/pro/Calendar/constants"
import styles from "../index.module.css"
import { useDevice } from "hooks/useDevice"

const TimeOffWeekdays = ({ timeOff, getDropdownItems }) => {
  const columns = getTimeOffColumns(TIME_OFF_BE_KEYS.weekDays)
  const { isMobile } = useDevice()

  if (!timeOff?.length) {
    return <TimeOffNotFound type="day(s) of the week" colSpan={columns.length} />
  }

  return (
    <tbody>
      {timeOff?.map((item, index) => {
        const { id, day, start_time, end_time, all_day, season_start, season_end } = item || {}
        let time
        if (all_day) {
          time = "Full day"
        } else {
          time = start_time && end_time ? `${start_time} - ${end_time}` : "-"
        }
        return (
          <tr key={`${id}-${index}`}>
            <td data-label={columns[0]}>
              <Text>{day}</Text>
            </td>
            <td data-label={columns[1]}>
              <Text>{time}</Text>
            </td>
            <td data-label={columns[2]}>
              <Text>{season_start}</Text>
            </td>
            <td data-label={columns[3]}>
              <Text>{season_end ?? "-"}</Text>
            </td>
            <td data-label={columns[4]} className={styles.actionColumn}>
              <Dropdown trigger={["click"]} placement="bottomRight" menu={{ items: getDropdownItems(item) }}>
                {isMobile ? <Text className={styles.moreText}> More actions</Text> : <MoreActionEllipsis />}
              </Dropdown>
            </td>
          </tr>
        )
      })}
    </tbody>
  )
}

TimeOffWeekdays.propTypes = {
  timeOff: PropTypes.array,
  getDropdownItems: PropTypes.func
}

export default TimeOffWeekdays
